import modes from '@/modules/datePickerModes';

export default function useFilter() {
  const now = new Date();

  return {
    from: new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()),
    to: now,
    mode: modes.lastWeek,
    territory: { name: null, alias: null },
  };
}
